export interface GetClientListModel {
  appId: string;
  perPage: number;
  currentPage: number;
  name: string;
  email: string;
  orderBy: 'OrderBy' | 'OrderByDescending';
  orderByOption: 'Name' | 'RegistrationDate' | 'TotalOrder' | 'Spent';
}
